/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import ScoresRadarChart, { ScoresRadarChartScoresInterface } from '../scores-radar-chart';
import { Portfolio } from '../../../types/portfolio';
import './styles.scss';

const PortfolioScoresRadarChart = ({ portfolio, width = 130, height = 130, showMaterialityChart = false }: { portfolio: Portfolio, width?: number, height?: number, showMaterialityChart?: boolean }) => {
  const goals = portfolio.scorecard.scorecard.goals;

  const sdgScores: ScoresRadarChartScoresInterface = {};
  goals.forEach(g => sdgScores[g.sdgCode] = g.actual ?? 0);

  const materialityGoals = {
    high: goals.filter(g => portfolio.materiality?.[g.sdgCode] === 100),
    medium: goals.filter(g => portfolio.materiality?.[g.sdgCode] === 66),
    low: goals.filter(g => (portfolio.materiality?.[g.sdgCode] ?? 0) < 66)
  }

  const materialityScores: ScoresRadarChartScoresInterface = {
    High: materialityGoals.high.length === 0 ? 0 :materialityGoals.high.reduce((acc, g) => acc += g.actual ?? 0, 0)/materialityGoals.high.length,
    Medium: materialityGoals.medium.length === 0 ? 0 :materialityGoals.medium.reduce((acc, g) => acc += g.actual ?? 0, 0)/materialityGoals.medium.length,
    Low: materialityGoals.low.length === 0 ? 0 :materialityGoals.low.reduce((acc, g) => acc += g.actual ?? 0, 0)/materialityGoals.low.length,
  };

  return (
    <div className='portfolio-scores-radar-chart'>
      <ScoresRadarChart scores={showMaterialityChart ? materialityScores : sdgScores} width={width} height={height} showMaterialityChart={showMaterialityChart} />
    </div>
  )
}

export default PortfolioScoresRadarChart;
